module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<a href="#members/'+
((__t=( member_id ))==null?'':_.escape(__t))+
'" oncontextmenu="return false">\n  <img class="author-mug '+
((__t=( party ))==null?'':_.escape(__t))+
'" src="'+
((__t=( require('../../../../images/cropped/icon_' + member_id + '.jpg') ))==null?'':__t)+
'"></a>\n  <span class="author-details d-inline-block ms-2">\n    <p class="author-name"><a href="#members/'+
((__t=( member_id ))==null?'':_.escape(__t))+
'" oncontextmenu="return false">'+
((__t=( full_name ))==null?'':_.escape(__t))+
'</a></p>\n    <p class="other">'+
((__t=( district_type ))==null?'':_.escape(__t))+
' '+
((__t=( district_number ))==null?'':_.escape(__t))+
'</p>\n    <p class="other">'+
((__t=( party ))==null?'':_.escape(__t))+
'-'+
((__t=( hometown ))==null?'':_.escape(__t))+
'</p>\n  </span>\n</a>';
}
return __p;
};
